export default {
  'monetization_revenue_Revenue': '付费流水',
  'monetization_revenue_Revenue($)': '付费金额({unit})', // 1
  'monetization_revenue_Revenue_Trends': '活跃ARPU & 付费ARPPU',// 2
  'monetization_revenue_Payer_And_Payer%': '付费人数&付费渗透率', // 5
  'monetization_revenue_Revenue_Channel_Distribution': '付费金额登录渠道构成', // 8 付费渠道构成分布
  'monetization_revenue_ARPU': '活跃ARPU', // 3
  'monetization_revenue_ARPPU': '付费ARPPU', // 4
  'monetization_revenue_Payer': '付费人数', // 6
  'monetization_revenue_Payer%': '付费渗透率', // 7


  'monetization_revenue_Country/Region/Zone_Breakdown': '国家/区域/区服排行榜', // 1
  'monetization_revenue_Country': '国家',
  'monetization_revenue_Region': '区域',
  'monetization_revenue_Zone': '区服',
  'monetization_revenue_Countries': '国家',
  'monetization_revenue_Regions': '区域',
  'monetization_revenue_Zones': '区服',
  'monetization_revenue_Share_Of_All': '全局占比', // 14
  'monetization_revenue_Revenue_of_top_10_Countries': '付费金额 TOP 10 国家', // 11
  'monetization_revenue_Revenue_of_top_10_Regions': '付费金额 TOP 10 区域', // 11
  'monetization_revenue_Revenue_of_top_10_Zones': '付费金额 TOP 10 区服', // 11

  'monetization_revenue_DAU': '日活跃', // 5
  'monetization_revenue_WAU': '周活跃', // 5
  'monetization_revenue_MAU': '月活跃', // 5
  'monetization_revenue_ARPPU($)': '付费ARPPU({unit})', // 7
  'monetization_revenue_ARPU($)': '活跃ARPU({unit})', // 8
  'monetization_revenue_Avg': '平均', //
  'monetization_revenue_Sum': '总', // 4
  'monetization_revenue_Revenue_Country_Distribution': '付费金额国家构成', // 12
  'monetization_revenue_Revenue_Region_Distribution': '付费金额区域构成', // 12
  'monetization_revenue_Revenue_Zone_Distribution': '付费金额区服构成', // 12

  'monetization_revenue_Avg.Revenue($)': '平均付费金额({unit})', // 5


  'monetization_revenue_Share': '占比',
  'monetization_revenue_Date': '日期',

  'monetization_revenue_Overall_Payment': '总体付费表现',
  'monetization_revenue_Total_Revenue($)': '总付费金额({unit})',
  'monetization_revenue_ARPP': '单次付费收益', // 3
  'monetization_revenue_Payer%(new users)': '付费渗透率（新进用户）', // 3
  'monetization_revenue_New_Payer': '首次付费用户', // 3
  'monetization_revenue_Revenue(new_users)': '首次付费用户金额', // 3
  'monetization_revenue_New_users_ARPPU($)': '首次付费用户ARPPU({unit})', // 3
  'monetization_revenue_New_users_ARPU($)': '新进用户付费ARPU', // 3
  'monetization_revenue_Total_Pay_Days': '总付费天数', // 3
  
}

